import type { JSX } from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { TrendingPetitions } from './components/TrendingPetitions';
import { useTrendingPetitions } from './hooks/useTrendingPetitions';

export function TrendingPetitionsImpact(): JSX.Element {
	const {
		data: { trendingPetitions, sapCtaUrl },
		actions: { trackSapClick },
	} = useTrendingPetitions();

	return (
		<div className="bg-fill-inverse-weak py-20">
			<div className="container">
				<Text as="h2" variant="heading" size="large" className="text-center">
					<Translate value="fe.pages.impact.your_voice.title" />
				</Text>
				<TrendingPetitions trendingPetitions={trendingPetitions} />
				<div className="flex flex-col items-center justify-center text-center">
					<Text as="h3" variant="heading" size="x-small" className="mt-10">
						<Translate value="fe.pages.impact.create_change" />
					</Text>
					<Button
						as="a"
						className="mt-4"
						variant="primary"
						onClick={trackSapClick}
						href={sapCtaUrl}
						data-qa="start-a-petition-button"
					>
						<Translate value="fe.pages.home.start_a_petition" />
					</Button>
				</div>
			</div>
		</div>
	);
}
